export default __webpack_public_path__ + "static/media/ASR_IMG3409.bc99dea2.jpg";